<script setup>
import { computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import AgentFormModal from './AgentFormModal.vue';

defineProps({
  standalone: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'created']);

const store = useStore();
const { t } = useI18n();

const uiFlags = useMapGetter('agents/getUIFlags');
const isSubmitting = computed(() => uiFlags.value.isCreating);

const addAgent = async form => {
  try {
    await store.dispatch('agents/create', {
      name: form.name,
      email: form.email,
      display_name: form.displayName,
      phone_number: form.phone,
      availability: form.availability,
      role: form.role,
      custom_role_id: form.customRoleId,
      team_assignments: form.teamAssignments,
    });
    useAlert(t('AGENT_MGMT.ADD.API.SUCCESS_MESSAGE'));
    emit('created');
    emit('close');
  } catch (error) {
    const {
      response: {
        data: {
          error: errorResponse = '',
          attributes: attributes = [],
          message: attrError = '',
        } = {},
      } = {},
    } = error;

    let errorMessage = '';
    if (error?.response?.status === 422 && !attributes.includes('base')) {
      errorMessage = t('AGENT_MGMT.ADD.API.EXIST_MESSAGE');
    } else {
      errorMessage = t('AGENT_MGMT.ADD.API.ERROR_MESSAGE');
    }
    useAlert(errorResponse || attrError || errorMessage);
  }
};
</script>

<template>
  <AgentFormModal
    :title="$t('AGENT_MGMT.ADD.TITLE')"
    :description="$t('AGENT_MGMT.ADD.DESC')"
    :submit-label="$t('AGENT_MGMT.ADD.FORM.SUBMIT')"
    submit-icon="i-lucide-user-round-plus"
    :is-submitting="isSubmitting"
    :standalone="standalone"
    center-mobile-actions
    mobile-layout
    show-invitation-notice
    @close="emit('close')"
    @submit="addAgent"
  />
</template>
